export const ellipse = (content: string, limit: number): string => {
  if (content.length <= limit) return content;
  return content.substring(0, limit) + '...';
};
